// removed by extract-text-webpack-plugin
module.exports = {"container":"fHQLEB6y_U4OWhBFYbuiP","icon":"E05H8AhayttcVypcjRJio","menu":"_3mbYUEIkBNQ5OCv0UB-ue9","active":"D3swKjJ1Aw14rzWTHfrAy","account":"_271zflK-E4wjvEHWaTeEjn","name":"_3F1Nc2ezFwvtaEE_xwG0Hp","email":"_3YW3Uo_3rS_t_HRmr1LL6L","menuLink":"mMFEfEHAk8PmXCP25GQ-g","signature":"_2PJm1zhJCWpivI2KdYHNtt","button":"_1xQLbbr6HMw72HLQwx6ayW"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Layout/styles.css
// module id = 2664
// module chunks = 0